export default __webpack_public_path__ + "static/media/Luxtelligence.7c78ffde.png";